class VersionChecker {
	async getServerVersion() {
		try {
			const baseUrl = window.location.origin
			console.log('[Version Check] Fetching version from server')
			const response = await fetch(`${baseUrl}/api/version?_=${Date.now()}`, {
				cache: 'no-store'
			})
			const packageInfo = await response.json()
			console.log(`[Version Check] Server version: ${packageInfo.version}`)
			return {
				version: packageInfo.version,
				releaseDate: new Date().toISOString()
			}
		} catch (error) {
			console.error('[Version Check] Failed:', error)
			return null
		}
	}

	compareVersions(currentVersion, serverVersion) {
		if (!currentVersion || !serverVersion) return false

		console.log(`[Version Check] Comparing versions: ${currentVersion} vs ${serverVersion}`)
		const currentParts = currentVersion.split('.').map(Number)
		const serverParts = serverVersion.split('.').map(Number)

		// Compare major
		if (currentParts[0] !== serverParts[0]) return currentParts[0] < serverParts[0]
		// Compare minor
		if (currentParts[1] !== serverParts[1]) return currentParts[1] < serverParts[1]
		// Compare patch
		return currentParts[2] < serverParts[2]
	}

	async checkForUpdates(currentVersion) {
		console.log('[Version Check] Starting update check')
		const versionInfo = await this.getServerVersion()
		if (!versionInfo) return { hasUpdate: false }

		const hasUpdate = this.compareVersions(currentVersion, versionInfo.version)

		if (hasUpdate) {
			console.log(`[Version Check] Update found: ${currentVersion} -> ${versionInfo.version}`)
		} else {
			console.log('[Version Check] No update needed')
		}

		return {
			hasUpdate,
			version: versionInfo.version
		}
	}
}

export default new VersionChecker()
